import React, { useState } from 'react'
import { FAQEntry } from '../../utils/types'
import { trackEvent } from '../../utils/tracking/mixpanel'
import { useMatchScreen } from '../../context/MatchScreenContext'
import '../../styles/FAQSection/FAQSection.scss'

interface FAQRowProps {
    faqEntry: FAQEntry
}

const FAQRow = (props: FAQRowProps) => {
  const [activeFlag, setActiveFlag] = useState(false)
  const { question, answer } = props.faqEntry
  const { state: { pageKey } } = useMatchScreen()

  const toggleActive = () => {
    const nextActiveState = !activeFlag
    setActiveFlag(nextActiveState)
    trackClickEvent(nextActiveState)
  }

  const trackClickEvent = (active: boolean) => {
    const position = active ? 'open' : 'closed'

    trackEvent('MatchScreen', 'handoff-faq-accordion-click', {
      page_key: pageKey,
      title: question,
      position
    })
  }

  return (
        <div className="faq_row">
            <div className="faq_wrapper">
                <h4 className={`faq_trigger ${activeFlag ? 'close' : ''}`} onClick={() => toggleActive()}>
                    {question}
                </h4>
                <div className={`faq_content ${activeFlag ? 'active' : ''}`}>
                    {answer}
                </div>
            </div>
        </div>
  )
}

export default FAQRow
